import React from 'react';
import PropTypes from 'prop-types';
import { fill, isNil } from 'lodash';
import { connect } from 'react-redux';
import Square from './Square';
import {
  openDeleteGlobalOccurrenceModal,
  openOccurrenceEditModal
} from '../../data/experimentalDesign/modalActions';

const OccurrenceRow = props => {
  /**
   * Handles the dragging event of a Square component inside an Occurrence Row
   * @param event
   * @param occurrence
   */
  const globalOccurrenceDragHandler = (event, occurrence) => {
    event.dataTransfer.setData(`type/${occurrence.type}`, true);
    event.dataTransfer.setData('isNew', true);
    event.dataTransfer.setData('occurrence', JSON.stringify(occurrence));
    event.dataTransfer.effectAllowed = 'copy';
  };

  const emptyGrid = fill(Array(props.slotsSize), null);

  /**
   * Grid of Squares (Occurrences & Signals)
   */
  const filledGrid = emptyGrid.map((e, i) => {
    return isNil(props.occurrences) || props.occurrences[i] === undefined ? (
      <Square key={i} />
    ) : (
      <Square
        key={i}
        dragHandler={globalOccurrenceDragHandler}
        deletable
        editable
        draggable={props.draggable}
        occurrence={props.occurrences[i]}
        editHandler={() => {
          props.dispatch(openOccurrenceEditModal(props.occurrences[i], props.occurrences[i].type));
        }}
        deleteHandler={() => {
          props.dispatch(
            openDeleteGlobalOccurrenceModal(
              props.occurrences[i].id,
              props.occurrences[i].type,
              props.occurrences[i].name,
              props.occurrences[i].version_id
            )
          );
        }}
      />
    );
  });

  return (
    <div className="grid-dashboard">
      <div className="grid-dashboard__wrapper">
        <div className="square-list">{filledGrid}</div>
      </div>
    </div>
  );
};

OccurrenceRow.propTypes = {
  occurrences: PropTypes.array,
  draggable: PropTypes.bool,
  slotsSize: PropTypes.number,
  editHandler: PropTypes.func,
  deleteHandler: PropTypes.func
};

OccurrenceRow.defaultProps = {
  occurrences: [],
  draggable: false,
  slotsSize: 1500
};

export default connect()(OccurrenceRow);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/experimentalDesign/OccurrenceRow.js